import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=232d9fe1&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "../../../common/styles/preflight.scss?vue&type=style&index=0&prod&lang=css&"
import style1 from "./main.scss?vue&type=style&index=1&id=232d9fe1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d9fe1",
  null
  
)

export default component.exports